import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper';
import 'swiper/css';

// Import gallery images for client logos
import course1 from '../../assets/images/gallery/courses/1.jpg';
import course2 from '../../assets/images/gallery/courses/2.jpg';
import course3 from '../../assets/images/gallery/courses/3.jpg';
import course4 from '../../assets/images/gallery/courses/4.jpg';
import events1 from '../../assets/images/gallery/events/1.jpg';
import events2 from '../../assets/images/gallery/events/2.jpg';
import events3 from '../../assets/images/gallery/events/3.jpg';
import events4 from '../../assets/images/gallery/events/4.jpg';
import workshops1 from '../../assets/images/gallery/workshops/1.jpg';
import workshops2 from '../../assets/images/gallery/workshops/2.jpg';
import workshops3 from '../../assets/images/gallery/workshops/3.jpg';
import workshops4 from '../../assets/images/gallery/workshops/4.jpg';

// Client/Partner logos - using the gallery images as placeholders
// In a real app, you would use actual partner/client logos
const clientLogos = [
  {
    id: 1,
    name: 'Partner 1',
    logo: course1
  },
  {
    id: 2,
    name: 'Partner 2',
    logo: course2
  },
  {
    id: 3,
    name: 'Partner 3',
    logo: course3
  },
  {
    id: 4,
    name: 'Partner 4',
    logo: course4
  },
  {
    id: 5,
    name: 'Partner 5',
    logo: events1
  },
  {
    id: 6,
    name: 'Partner 6',
    logo: events2
  },
  {
    id: 7,
    name: 'Partner 7',
    logo: events3
  },
  {
    id: 8,
    name: 'Partner 8',
    logo: events4
  },
  {
    id: 9,
    name: 'Partner 9',
    logo: workshops1
  },
  {
    id: 10,
    name: 'Partner 10',
    logo: workshops2
  },
  {
    id: 11,
    name: 'Partner 11',
    logo: workshops3
  },
  {
    id: 12,
    name: 'Partner 12',
    logo: workshops4
  }
];

const ClientsSection = () => {
  return (
    <section className="py-10 bg-theme-top-gray">
      <div className="container mx-auto px-4">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={30}
          slidesPerView={2}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          loop={true}
          breakpoints={{
            640: {
              slidesPerView: 3,
            },
            768: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 6,
            },
          }}
          className="clients-slider"
        >
          {clientLogos.map((client) => (
            <SwiperSlide key={client.id}>
              <div className="flex items-center justify-center">
                <div className="bg-white p-4 rounded-lg shadow h-24 w-full flex items-center justify-center overflow-hidden hover:shadow-md transition-shadow">
                  <img 
                    src={client.logo} 
                    alt={client.name}
                    className="max-h-full max-w-full object-cover filter grayscale hover:grayscale-0 transition-all duration-300"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ClientsSection; 